import { FC } from 'react'

import FooterInfoLinkItem, { FooterInfoLinkItemProps } from '@/components/Layout/Footer/Atoms/FooterInfoLinkItem'
import '@/components/Layout/Footer/Molecules/FooterInfoLinks/FooterInfoLinkItem.scss'

export type FooterInfoLinksProps = {
  items: readonly FooterInfoLinkItemProps[]
}

const FooterInfoLinks: FC<FooterInfoLinksProps> = ({ items }) => {
  return (
    <ul className="c-footer-InfoLinks">
      {items.map((item) => {
        return (
          <FooterInfoLinkItem
            key={item.labelEn}
            className="l-footer-InfoLinks__children"
            labelEn={item.labelEn}
            labelJa={item.labelJa}
            href={item.href}
            iconImage={item.iconImage}
            description={item.description}
          />
        )
      })}
    </ul>
  )
}

export default FooterInfoLinks
